import CustomerViewerActivity, { takesTarget } from 'models/customer_viewer_activity';

/**
 * ReportCustomerViewing publishes that this session is on a customer page, and what
 * it's doing there. Called on arrival, then on a heartbeat, and again whenever the
 * activity changes.
 *
 * `arrivedAt` is carried by the caller across heartbeats rather than re-derived
 * here, so the elapsed time other agents see counts from when this session became
 * present instead of resetting every 15 seconds.
 */
export default class ReportCustomerViewing {
  constructor(context) {
    this.context = context;
  }

  run({ activity, activityTarget, customerId, arrivedAt }) {
    // The gateway's endpoint only learns its orgId when LogIn calls initGateways,
    // and building the url without it throws. Also covers the logout teardown,
    // where the endpoint's params are cleared again.
    if (!customerId || !this.context.stores.auth.get().isLoggedIn()) {
      return;
    }

    const effectiveActivity = activity || CustomerViewerActivity.VIEWING;

    // Fire and forget: an MQTT publish rather than a request, so there is no
    // response to await. A failed publish is corrected by the next renewal, and if
    // renewals stop entirely the record's expiry removes it.
    this.context.gateways.customerViewers.reportViewing(customerId, {
      activity: effectiveActivity,
      activityTarget: takesTarget(effectiveActivity) ? activityTarget : undefined,
      arrivedAt,
    });
  }
}
